// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var Quote = "Quote-module--Quote--14IfD";
export var Quote__wrapper = "Quote-module--Quote__wrapper--20ofo";
export var Quote__contentContainer = "Quote-module--Quote__contentContainer--V98W9";
export var Quote__contentContainer__copy = "Quote-module--Quote__contentContainer__copy--jDTkK";
export var Quote__contentContainer__quoteMarks = "Quote-module--Quote__contentContainer__quoteMarks--3Pe20";
export var Quote__cta = "Quote-module--Quote__cta--1XDGK";